query MfaScansList(
	$runId: ConditionID!
	$totalIssuesMinFilter: ConditionInt
	$scanNameFilter: ConditionString
	$textSearch: mfa_scans_listSearchInsensitive
	$offset: Int
	$limit: Int
	$sort: mfa_scans_listSort
) {
	mfa_scans_list(
		run_id_eq: $runId
		total_issues_gt: $totalIssuesMinFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
	) {
		tenant_id
		run_id
		scan_id
		scan_name
		scan_created_at
		scan_screenshot_url
		total_issues
		critical_issues
		serious_issues
		elements_with_issues
	}

	total: mfa_scans_list(
		run_id_eq: $runId
		total_issues_gt: $totalIssuesMinFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
	) {
		total_issues
		elements_with_issues
	}
}
